var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _linearGradient17, _linearGradient18, _linearGradient19, _linearGradient20, _linearGradient21, _linearGradient22, _linearGradient23, _linearGradient24, _linearGradient25, _linearGradient26, _linearGradient27, _linearGradient28, _linearGradient29, _linearGradient30, _linearGradient31, _linearGradient32, _linearGradient33, _linearGradient34, _linearGradient35, _linearGradient36, _linearGradient37, _linearGradient38, _linearGradient39, _linearGradient40, _linearGradient41, _linearGradient42, _linearGradient43, _linearGradient44, _linearGradient45, _linearGradient46, _linearGradient47, _linearGradient48, _linearGradient49, _linearGradient50, _linearGradient51, _linearGradient52, _linearGradient53, _linearGradient54, _linearGradient55, _linearGradient56, _linearGradient57, _linearGradient58, _linearGradient59, _linearGradient60, _linearGradient61, _linearGradient62, _linearGradient63, _linearGradient64, _linearGradient65, _linearGradient66, _linearGradient67, _linearGradient68, _linearGradient69, _linearGradient70, _linearGradient71, _linearGradient72, _linearGradient73, _linearGradient74, _linearGradient75, _linearGradient76, _linearGradient77, _path, _circle, _circle2, _path2, _circle3, _circle4, _path3, _circle5, _circle6, _path4, _circle7, _circle8, _path5, _path6, _path7, _circle9, _path8, _circle10, _path9, _circle11, _path10, _circle12, _circle13, _circle14, _path11, _circle15, _circle16, _path12, _circle17, _circle18, _path13, _circle19, _circle20, _path14, _path15, _path16, _circle21, _path17, _circle22, _path18, _circle23, _path19, _circle24, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _circle25, _circle26, _path34, _circle27, _circle28, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconHighSpeedTrain(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 510 510",
    height: 512,
    viewBox: "0 0 510 510",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff4974"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2231,
    stopColor: "#fb3f6c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6075,
    stopColor: "#f12357"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e4003d"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 286.062,
    x2: 286.062,
    xlinkHref: "#lg1",
    y1: 189.179,
    y2: 214.915
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4f4a72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3b395f"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 67.295,
    x2: 87.723,
    xlinkHref: "#lg2",
    y1: 299.905,
    y2: 320.333
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientTransform: "matrix(-1 0 0 -1 224.453 -244.679)",
    gradientUnits: "userSpaceOnUse",
    x1: 148.442,
    x2: 164.019,
    xlinkHref: "#lg2",
    y1: -553.3,
    y2: -537.723
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg3"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3b395f",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3b395f"
  }))), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 82.237,
    x2: 67.557,
    xlinkHref: "#lg3",
    y1: 309.254,
    y2: 289.733
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 103.441,
    x2: 123.869,
    xlinkHref: "#lg2",
    y1: 299.905,
    y2: 320.333
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientTransform: "matrix(-1 0 0 -1 224.453 -244.679)",
    gradientUnits: "userSpaceOnUse",
    x1: 112.295,
    x2: 127.873,
    xlinkHref: "#lg2",
    y1: -553.3,
    y2: -537.723
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 118.384,
    x2: 103.704,
    xlinkHref: "#lg3",
    y1: 309.254,
    y2: 289.733
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 139.587,
    x2: 160.015,
    xlinkHref: "#lg2",
    y1: 299.905,
    y2: 320.333
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientTransform: "matrix(-1 0 0 -1 224.453 -244.679)",
    gradientUnits: "userSpaceOnUse",
    x1: 76.149,
    x2: 91.727,
    xlinkHref: "#lg2",
    y1: -553.3,
    y2: -537.723
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 154.53,
    x2: 139.85,
    xlinkHref: "#lg3",
    y1: 309.254,
    y2: 289.733
  })), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 175.734,
    x2: 196.161,
    xlinkHref: "#lg2",
    y1: 299.905,
    y2: 320.333
  })), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientTransform: "matrix(-1 0 0 -1 224.453 -244.679)",
    gradientUnits: "userSpaceOnUse",
    x1: 40.003,
    x2: 55.581,
    xlinkHref: "#lg2",
    y1: -553.3,
    y2: -537.723
  })), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 190.676,
    x2: 175.996,
    xlinkHref: "#lg3",
    y1: 309.254,
    y2: 289.733
  })), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg4"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d4f7ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a2e3e9"
  }))), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 126.459,
    x2: 126.459,
    xlinkHref: "#lg4",
    y1: 302.623,
    y2: 307.165
  })), _linearGradient19 || (_linearGradient19 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 82.949,
    x2: 70.895,
    xlinkHref: "#lg3",
    y1: 315.559,
    y2: 303.505
  })), _linearGradient20 || (_linearGradient20 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg5"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe548"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1758,
    stopColor: "#ffde50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4446,
    stopColor: "#ffca65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7709,
    stopColor: "#ffaa87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff90a4"
  }))), _linearGradient21 || (_linearGradient21 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 71.386,
    x2: 75.725,
    xlinkHref: "#lg5",
    y1: 303.996,
    y2: 308.335
  })), _linearGradient22 || (_linearGradient22 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: 119.096,
    x2: 107.041,
    xlinkHref: "#lg3",
    y1: 315.559,
    y2: 303.505
  })), _linearGradient23 || (_linearGradient23 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: 107.532,
    x2: 111.871,
    xlinkHref: "#lg5",
    y1: 303.996,
    y2: 308.335
  })), _linearGradient24 || (_linearGradient24 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_",
    gradientUnits: "userSpaceOnUse",
    x1: 155.242,
    x2: 143.187,
    xlinkHref: "#lg3",
    y1: 315.559,
    y2: 303.505
  })), _linearGradient25 || (_linearGradient25 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_20_",
    gradientUnits: "userSpaceOnUse",
    x1: 143.679,
    x2: 148.018,
    xlinkHref: "#lg5",
    y1: 303.996,
    y2: 308.335
  })), _linearGradient26 || (_linearGradient26 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_21_",
    gradientUnits: "userSpaceOnUse",
    x1: 191.388,
    x2: 179.333,
    xlinkHref: "#lg3",
    y1: 315.559,
    y2: 303.505
  })), _linearGradient27 || (_linearGradient27 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_22_",
    gradientUnits: "userSpaceOnUse",
    x1: 179.825,
    x2: 184.164,
    xlinkHref: "#lg5",
    y1: 303.996,
    y2: 308.335
  })), _linearGradient28 || (_linearGradient28 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_23_",
    gradientUnits: "userSpaceOnUse",
    x1: 226.897,
    x2: 247.325,
    xlinkHref: "#lg2",
    y1: 299.905,
    y2: 320.333
  })), _linearGradient29 || (_linearGradient29 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_24_",
    gradientTransform: "matrix(-1 0 0 -1 224.453 -244.679)",
    gradientUnits: "userSpaceOnUse",
    x1: -11.161,
    x2: 4.417,
    xlinkHref: "#lg2",
    y1: -553.3,
    y2: -537.723
  })), _linearGradient30 || (_linearGradient30 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_25_",
    gradientUnits: "userSpaceOnUse",
    x1: 241.84,
    x2: 227.16,
    xlinkHref: "#lg3",
    y1: 309.254,
    y2: 289.733
  })), _linearGradient31 || (_linearGradient31 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_26_",
    gradientUnits: "userSpaceOnUse",
    x1: 263.043,
    x2: 283.471,
    xlinkHref: "#lg2",
    y1: 299.905,
    y2: 320.333
  })), _linearGradient32 || (_linearGradient32 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_27_",
    gradientTransform: "matrix(-1 0 0 -1 224.453 -244.679)",
    gradientUnits: "userSpaceOnUse",
    x1: -47.307,
    x2: -31.729,
    xlinkHref: "#lg2",
    y1: -553.3,
    y2: -537.723
  })), _linearGradient33 || (_linearGradient33 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_28_",
    gradientUnits: "userSpaceOnUse",
    x1: 277.986,
    x2: 263.306,
    xlinkHref: "#lg3",
    y1: 309.254,
    y2: 289.733
  })), _linearGradient34 || (_linearGradient34 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_29_",
    gradientUnits: "userSpaceOnUse",
    x1: 299.189,
    x2: 319.617,
    xlinkHref: "#lg2",
    y1: 299.905,
    y2: 320.333
  })), _linearGradient35 || (_linearGradient35 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_30_",
    gradientTransform: "matrix(-1 0 0 -1 224.453 -244.679)",
    gradientUnits: "userSpaceOnUse",
    x1: -83.453,
    x2: -67.875,
    xlinkHref: "#lg2",
    y1: -553.3,
    y2: -537.723
  })), _linearGradient36 || (_linearGradient36 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_31_",
    gradientUnits: "userSpaceOnUse",
    x1: 314.132,
    x2: 299.452,
    xlinkHref: "#lg3",
    y1: 309.254,
    y2: 289.733
  })), _linearGradient37 || (_linearGradient37 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_32_",
    gradientUnits: "userSpaceOnUse",
    x1: 335.336,
    x2: 355.764,
    xlinkHref: "#lg2",
    y1: 299.905,
    y2: 320.333
  })), _linearGradient38 || (_linearGradient38 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_33_",
    gradientTransform: "matrix(-1 0 0 -1 224.453 -244.679)",
    gradientUnits: "userSpaceOnUse",
    x1: -119.599,
    x2: -104.022,
    xlinkHref: "#lg2",
    y1: -553.3,
    y2: -537.723
  })), _linearGradient39 || (_linearGradient39 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_34_",
    gradientUnits: "userSpaceOnUse",
    x1: 350.278,
    x2: 335.598,
    xlinkHref: "#lg3",
    y1: 309.254,
    y2: 289.733
  })), _linearGradient40 || (_linearGradient40 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_35_",
    gradientUnits: "userSpaceOnUse",
    x1: 286.062,
    x2: 286.062,
    xlinkHref: "#lg4",
    y1: 302.623,
    y2: 307.165
  })), _linearGradient41 || (_linearGradient41 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_36_",
    gradientUnits: "userSpaceOnUse",
    x1: 242.552,
    x2: 230.497,
    xlinkHref: "#lg3",
    y1: 315.559,
    y2: 303.505
  })), _linearGradient42 || (_linearGradient42 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_37_",
    gradientUnits: "userSpaceOnUse",
    x1: 230.988,
    x2: 235.327,
    xlinkHref: "#lg5",
    y1: 303.996,
    y2: 308.335
  })), _linearGradient43 || (_linearGradient43 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_38_",
    gradientUnits: "userSpaceOnUse",
    x1: 278.698,
    x2: 266.643,
    xlinkHref: "#lg3",
    y1: 315.559,
    y2: 303.505
  })), _linearGradient44 || (_linearGradient44 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_39_",
    gradientUnits: "userSpaceOnUse",
    x1: 267.135,
    x2: 271.473,
    xlinkHref: "#lg5",
    y1: 303.996,
    y2: 308.335
  })), _linearGradient45 || (_linearGradient45 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_40_",
    gradientUnits: "userSpaceOnUse",
    x1: 314.844,
    x2: 302.789,
    xlinkHref: "#lg3",
    y1: 315.559,
    y2: 303.505
  })), _linearGradient46 || (_linearGradient46 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_41_",
    gradientUnits: "userSpaceOnUse",
    x1: 303.281,
    x2: 307.62,
    xlinkHref: "#lg5",
    y1: 303.996,
    y2: 308.335
  })), _linearGradient47 || (_linearGradient47 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_42_",
    gradientUnits: "userSpaceOnUse",
    x1: 350.99,
    x2: 338.936,
    xlinkHref: "#lg3",
    y1: 315.559,
    y2: 303.505
  })), _linearGradient48 || (_linearGradient48 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_43_",
    gradientUnits: "userSpaceOnUse",
    x1: 339.427,
    x2: 343.766,
    xlinkHref: "#lg5",
    y1: 303.996,
    y2: 308.335
  })), _linearGradient49 || (_linearGradient49 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_44_",
    gradientUnits: "userSpaceOnUse",
    x1: 178.615,
    x2: 234.796,
    xlinkHref: "#lg4",
    y1: 216.123,
    y2: 296.044
  })), _linearGradient50 || (_linearGradient50 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg6"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a34a9e",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343168"
  }))), _linearGradient51 || (_linearGradient51 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_45_",
    gradientUnits: "userSpaceOnUse",
    x1: 120.622,
    x2: 30.65,
    xlinkHref: "#lg6",
    y1: 270.689,
    y2: 180.717
  })), _linearGradient52 || (_linearGradient52 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_46_",
    gradientUnits: "userSpaceOnUse",
    x1: 326.908,
    x2: 405.945,
    xlinkHref: "#lg4",
    y1: 221.97,
    y2: 315.936
  })), _linearGradient53 || (_linearGradient53 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_47_",
    gradientUnits: "userSpaceOnUse",
    x1: 235.135,
    x2: 316.459,
    xlinkHref: "#lg4",
    y1: 221.329,
    y2: 318.014
  })), _linearGradient54 || (_linearGradient54 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_48_",
    gradientUnits: "userSpaceOnUse",
    x1: 209.447,
    x2: 236.428,
    xlinkHref: "#lg6",
    y1: 238.324,
    y2: 13.195
  })), _linearGradient55 || (_linearGradient55 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_49_",
    gradientUnits: "userSpaceOnUse",
    x1: 201.431,
    x2: 201.431,
    xlinkHref: "#lg1",
    y1: 280.89,
    y2: 323.939
  })), _linearGradient56 || (_linearGradient56 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_50_",
    gradientUnits: "userSpaceOnUse",
    x1: 234.972,
    x2: 234.972,
    xlinkHref: "#lg2",
    y1: 229.629,
    y2: 257.817
  })), _linearGradient57 || (_linearGradient57 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_51_",
    gradientUnits: "userSpaceOnUse",
    x1: 82.872,
    x2: 82.872,
    xlinkHref: "#lg2",
    y1: 201.168,
    y2: 289.42
  })), _linearGradient58 || (_linearGradient58 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg7"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3fa9f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#666ad6"
  }))), _linearGradient59 || (_linearGradient59 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_52_",
    gradientUnits: "userSpaceOnUse",
    x1: 239.109,
    x2: 274.575,
    xlinkHref: "#lg7",
    y1: 232.74,
    y2: 283.191
  })), _linearGradient60 || (_linearGradient60 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_53_",
    gradientUnits: "userSpaceOnUse",
    x1: 351.399,
    x2: 395.528,
    xlinkHref: "#lg4",
    y1: 247.601,
    y2: 295.682
  })), _linearGradient61 || (_linearGradient61 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_54_",
    gradientUnits: "userSpaceOnUse",
    x1: 353.655,
    x2: 353.655,
    xlinkHref: "#lg4",
    y1: 271.55,
    y2: 266.106
  })), _linearGradient62 || (_linearGradient62 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_55_",
    gradientUnits: "userSpaceOnUse",
    x1: 365.943,
    x2: 365.943,
    xlinkHref: "#lg2",
    y1: 222.036,
    y2: 274.427
  })), _linearGradient63 || (_linearGradient63 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_56_",
    gradientUnits: "userSpaceOnUse",
    x1: 194.574,
    x2: 297.645,
    xlinkHref: "#lg2",
    y1: 271.246,
    y2: 383.547
  })), _linearGradient64 || (_linearGradient64 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_57_",
    gradientUnits: "userSpaceOnUse",
    x1: 390.986,
    x2: 415.136,
    xlinkHref: "#lg2",
    y1: 236.042,
    y2: 258.436
  })), _linearGradient65 || (_linearGradient65 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_58_",
    gradientUnits: "userSpaceOnUse",
    x1: 440.001,
    x2: 460.429,
    xlinkHref: "#lg2",
    y1: 299.905,
    y2: 320.333
  })), _linearGradient66 || (_linearGradient66 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_59_",
    gradientTransform: "matrix(-1 0 0 -1 224.453 -244.679)",
    gradientUnits: "userSpaceOnUse",
    x1: -224.264,
    x2: -208.687,
    xlinkHref: "#lg2",
    y1: -553.3,
    y2: -537.723
  })), _linearGradient67 || (_linearGradient67 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_60_",
    gradientUnits: "userSpaceOnUse",
    x1: 454.943,
    x2: 440.263,
    xlinkHref: "#lg3",
    y1: 309.254,
    y2: 289.733
  })), _linearGradient68 || (_linearGradient68 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_61_",
    gradientUnits: "userSpaceOnUse",
    x1: 476.147,
    x2: 496.575,
    xlinkHref: "#lg2",
    y1: 299.905,
    y2: 320.333
  })), _linearGradient69 || (_linearGradient69 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_62_",
    gradientTransform: "matrix(-1 0 0 -1 224.453 -244.679)",
    gradientUnits: "userSpaceOnUse",
    x1: -260.411,
    x2: -244.833,
    xlinkHref: "#lg2",
    y1: -553.3,
    y2: -537.723
  })), _linearGradient70 || (_linearGradient70 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_63_",
    gradientUnits: "userSpaceOnUse",
    x1: 491.089,
    x2: 476.409,
    xlinkHref: "#lg3",
    y1: 309.254,
    y2: 289.733
  })), _linearGradient71 || (_linearGradient71 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_64_",
    gradientUnits: "userSpaceOnUse",
    x1: 469.428,
    x2: 469.428,
    xlinkHref: "#lg1",
    y1: 189.179,
    y2: 214.915
  })), _linearGradient72 || (_linearGradient72 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_65_",
    gradientUnits: "userSpaceOnUse",
    x1: 438.048,
    x2: 516.712,
    xlinkHref: "#lg4",
    y1: 221.588,
    y2: 315.11
  })), _linearGradient73 || (_linearGradient73 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_66_",
    gradientUnits: "userSpaceOnUse",
    x1: 464.855,
    x2: 485.427,
    xlinkHref: "#lg6",
    y1: 243.613,
    y2: 71.97
  })), _linearGradient74 || (_linearGradient74 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_67_",
    gradientUnits: "userSpaceOnUse",
    x1: 463.019,
    x2: 463.019,
    xlinkHref: "#lg1",
    y1: 280.885,
    y2: 323.938
  })), _linearGradient75 || (_linearGradient75 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_68_",
    gradientUnits: "userSpaceOnUse",
    x1: 453.313,
    x2: 466.297,
    xlinkHref: "#lg7",
    y1: 256.48,
    y2: 274.95
  })), _linearGradient76 || (_linearGradient76 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_69_",
    gradientUnits: "userSpaceOnUse",
    x1: 453.534,
    x2: 482.678,
    xlinkHref: "#lg2",
    y1: 295.676,
    y2: 327.43
  })), _linearGradient77 || (_linearGradient77 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_70_",
    gradientUnits: "userSpaceOnUse",
    x1: 469.428,
    x2: 469.428,
    xlinkHref: "#lg2",
    y1: 229.634,
    y2: 257.815
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m391.444 207.058h-210.765v-6.971c0-6.335 5.136-11.471 11.471-11.471h187.823c6.335 0 11.471 5.136 11.471 11.471z",
    fill: "url(#SVGID_1_)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 72.24,
    cy: 304.85,
    fill: "url(#SVGID_2_)",
    r: 16.534
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 72.24,
    cy: 304.85,
    fill: "url(#SVGID_3_)",
    r: 12.609
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m58.272 296.007 22.811 22.811c4.621-2.932 7.691-8.09 7.691-13.968 0-9.132-7.403-16.534-16.534-16.534-5.878 0-11.036 3.07-13.968 7.691z",
    fill: "url(#SVGID_4_)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 108.386,
    cy: 304.85,
    fill: "url(#SVGID_5_)",
    r: 16.534
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 108.386,
    cy: 304.85,
    fill: "url(#SVGID_6_)",
    r: 12.609
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m94.418 296.007 22.811 22.811c4.621-2.932 7.691-8.09 7.691-13.968 0-9.132-7.403-16.534-16.534-16.534-5.878 0-11.036 3.07-13.968 7.691z",
    fill: "url(#SVGID_7_)"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 144.533,
    cy: 304.85,
    fill: "url(#SVGID_8_)",
    r: 16.534
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 144.533,
    cy: 304.85,
    fill: "url(#SVGID_9_)",
    r: 12.609
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m130.565 296.007c1.228 1.228 15.487 15.486 22.811 22.811 4.621-2.932 7.691-8.09 7.691-13.968 0-9.132-7.403-16.534-16.534-16.534-5.879 0-11.036 3.07-13.968 7.691z",
    fill: "url(#SVGID_10_)"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 180.679,
    cy: 304.85,
    fill: "url(#SVGID_11_)",
    r: 16.534
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 180.679,
    cy: 304.85,
    fill: "url(#SVGID_12_)",
    r: 12.609
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m166.711 296.007c1.228 1.228 15.487 15.486 22.811 22.811 4.621-2.932 7.691-8.09 7.691-13.968 0-9.132-7.403-16.534-16.534-16.534-5.878 0-11.036 3.07-13.968 7.691z",
    fill: "url(#SVGID_13_)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m72.24 302.524h108.439v4.651h-108.439z",
    fill: "url(#SVGID_14_)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m83.571 310.383-8.239-8.239c-.754-.861-1.858-1.407-3.092-1.407-2.272 0-4.113 1.842-4.113 4.113 0 1.234.546 2.338 1.407 3.092l8.239 8.239c2.519-1.232 4.566-3.279 5.798-5.798z",
    fill: "url(#SVGID_15_)"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 72.24,
    cy: 304.85,
    fill: "url(#SVGID_16_)",
    r: 4.113
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m119.717 310.383-8.239-8.239c-.754-.861-1.858-1.407-3.092-1.407-2.272 0-4.113 1.842-4.113 4.113 0 1.234.546 2.338 1.407 3.092l8.239 8.239c2.519-1.232 4.566-3.279 5.798-5.798z",
    fill: "url(#SVGID_17_)"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 108.386,
    cy: 304.85,
    fill: "url(#SVGID_18_)",
    r: 4.113
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m155.864 310.383-8.239-8.239c-.754-.861-1.858-1.407-3.092-1.407-2.272 0-4.113 1.842-4.113 4.113 0 1.234.546 2.338 1.407 3.092l8.239 8.239c2.518-1.232 4.565-3.279 5.798-5.798z",
    fill: "url(#SVGID_19_)"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 144.533,
    cy: 304.85,
    fill: "url(#SVGID_20_)",
    r: 4.113
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m192.01 310.383-8.239-8.239c-.754-.861-1.858-1.407-3.092-1.407-2.272 0-4.113 1.842-4.113 4.113 0 1.234.546 2.338 1.407 3.092l8.239 8.239c2.519-1.232 4.566-3.279 5.798-5.798z",
    fill: "url(#SVGID_21_)"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 180.679,
    cy: 304.85,
    fill: "url(#SVGID_22_)",
    r: 4.113
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 231.842,
    cy: 304.85,
    fill: "url(#SVGID_23_)",
    r: 16.534
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 231.842,
    cy: 304.85,
    fill: "url(#SVGID_24_)",
    r: 12.609
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m217.874 296.007c1.228 1.228 15.487 15.486 22.811 22.811 4.621-2.932 7.691-8.09 7.691-13.968 0-9.132-7.403-16.534-16.534-16.534-5.878 0-11.036 3.07-13.968 7.691z",
    fill: "url(#SVGID_25_)"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 267.988,
    cy: 304.85,
    fill: "url(#SVGID_26_)",
    r: 16.534
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 267.988,
    cy: 304.85,
    fill: "url(#SVGID_27_)",
    r: 12.609
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m254.02 296.007c1.228 1.228 15.487 15.486 22.811 22.811 4.621-2.932 7.691-8.09 7.691-13.968 0-9.132-7.403-16.534-16.534-16.534-5.878 0-11.035 3.07-13.968 7.691z",
    fill: "url(#SVGID_28_)"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 304.135,
    cy: 304.85,
    fill: "url(#SVGID_29_)",
    r: 16.534
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 304.135,
    cy: 304.85,
    fill: "url(#SVGID_30_)",
    r: 12.609
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m290.167 296.007 22.811 22.811c4.621-2.932 7.691-8.09 7.691-13.968 0-9.132-7.403-16.534-16.534-16.534-5.878 0-11.036 3.07-13.968 7.691z",
    fill: "url(#SVGID_31_)"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 340.281,
    cy: 304.85,
    fill: "url(#SVGID_32_)",
    r: 16.534
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 340.281,
    cy: 304.85,
    fill: "url(#SVGID_33_)",
    r: 12.609
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m326.313 296.007c1.228 1.228 15.487 15.486 22.811 22.811 4.621-2.932 7.691-8.09 7.691-13.968 0-9.132-7.403-16.534-16.534-16.534-5.878 0-11.036 3.07-13.968 7.691z",
    fill: "url(#SVGID_34_)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m231.842 302.524h108.439v4.651h-108.439z",
    fill: "url(#SVGID_35_)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "m243.173 310.383-8.239-8.239c-.754-.861-1.858-1.407-3.092-1.407-2.272 0-4.113 1.842-4.113 4.113 0 1.234.546 2.338 1.407 3.092l8.239 8.239c2.519-1.232 4.566-3.279 5.798-5.798z",
    fill: "url(#SVGID_36_)"
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 231.842,
    cy: 304.85,
    fill: "url(#SVGID_37_)",
    r: 4.113
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "m279.32 310.383-8.239-8.239c-.754-.861-1.858-1.407-3.092-1.407-2.272 0-4.113 1.842-4.113 4.113 0 1.234.546 2.338 1.407 3.092l8.239 8.239c2.518-1.232 4.565-3.279 5.798-5.798z",
    fill: "url(#SVGID_38_)"
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: 267.988,
    cy: 304.85,
    fill: "url(#SVGID_39_)",
    r: 4.113
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "m315.466 310.383-8.239-8.239c-.754-.861-1.858-1.407-3.092-1.407-2.272 0-4.113 1.842-4.113 4.113 0 1.234.546 2.338 1.407 3.092l8.239 8.239c2.518-1.232 4.565-3.279 5.798-5.798z",
    fill: "url(#SVGID_40_)"
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: 304.135,
    cy: 304.85,
    fill: "url(#SVGID_41_)",
    r: 4.113
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "m351.612 310.383-8.239-8.239c-.754-.861-1.858-1.407-3.092-1.407-2.272 0-4.113 1.842-4.113 4.113 0 1.234.546 2.338 1.407 3.092l8.239 8.239c2.519-1.232 4.566-3.279 5.798-5.798z",
    fill: "url(#SVGID_42_)"
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: 340.281,
    cy: 304.85,
    fill: "url(#SVGID_43_)",
    r: 4.113
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "m23.636 310.796h368.999c5.647 0 10.225-4.578 10.225-10.225v-94.816c0-5.647-4.578-10.225-10.225-10.225h-199.903c-58.191 0-114.722 19.396-160.655 55.122l-22.952 17.851c-5.757 4.478-9.125 11.363-9.125 18.657 0 13.054 10.582 23.636 23.636 23.636z",
    fill: "url(#SVGID_44_)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "m156.064 198.12c-44.995 6.368-87.784 24.372-123.987 52.531l-22.221 17.283h63.51c23.681 0 45.729-12.065 58.497-32.009z",
    fill: "url(#SVGID_45_)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "m392.635 195.529h-83.741v115.267h83.741c5.647 0 10.225-4.578 10.225-10.225v-94.816c.001-5.648-4.577-10.226-10.225-10.226z",
    fill: "url(#SVGID_46_)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "m308.895 195.529h-93.967v115.267h93.966.001z",
    fill: "url(#SVGID_47_)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "m392.635 212.654h-199.903c-58.191 0-114.722 19.396-160.655 55.122l-22.952 17.852c-3.411 2.653-5.975 6.155-7.505 10.083 3.43 8.822 11.982 15.085 22.016 15.085h368.999c5.647 0 10.225-4.578 10.225-10.225v-77.691c.001-5.648-4.577-10.226-10.225-10.226z",
    fill: "url(#SVGID_48_)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "m1.137 279.948c-.739 2.305-1.137 4.734-1.137 7.212 0 13.054 10.582 23.636 23.636 23.636h368.999c5.647 0 10.225-4.578 10.225-10.225v-20.623z",
    fill: "url(#SVGID_49_)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "m334.253 249.211h-198.556c-2.885 0-4.7-3.11-3.28-5.622l7.157-12.663c.668-1.183 1.922-1.914 3.28-1.914h191.398c2.081 0 3.768 1.687 3.768 3.768v12.663c.001 2.081-1.686 3.768-3.767 3.768z",
    fill: "url(#SVGID_50_)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "m148.87 199.238c-42.355 7.202-82.524 24.76-116.793 51.414l-15.204 11.825h58.333c20.673 0 39.922-10.533 51.068-27.944z",
    fill: "url(#SVGID_51_)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "m402.861 273.8h-272.889c-1.94 0-3.513-1.573-3.513-3.513 0-1.94 1.573-3.513 3.513-3.513h272.889z",
    fill: "url(#SVGID_52_)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "m387.492 310.796h-43.098v-92.498c0-3.117 2.527-5.644 5.644-5.644h31.811c3.117 0 5.644 2.527 5.644 5.644v92.498z",
    fill: "url(#SVGID_53_)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "m356.125 270.288h-4.94c-1.046 0-1.894-.848-1.894-1.894 0-1.046.848-1.894 1.894-1.894h4.94c1.046 0 1.894.848 1.894 1.894-.001 1.046-.849 1.894-1.894 1.894z",
    fill: "url(#SVGID_54_)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "m372.206 258.432h-12.526c-1.738 0-3.148-1.409-3.148-3.148v-31.247c0-1.738 1.409-3.148 3.148-3.148h12.526c1.738 0 3.148 1.409 3.148 3.148v31.247c0 1.739-1.409 3.148-3.148 3.148z",
    fill: "url(#SVGID_55_)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "m392.635 310.796c4.118 0 7.657-2.439 9.278-5.946h-334.346c-5.046 0-9.849 2.165-13.19 5.946z",
    fill: "url(#SVGID_56_)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "m402.861 209.122h13.177v88.083h-13.177z",
    fill: "url(#SVGID_57_)"
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    cx: 444.946,
    cy: 304.85,
    fill: "url(#SVGID_58_)",
    r: 16.534
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    cx: 444.946,
    cy: 304.85,
    fill: "url(#SVGID_59_)",
    r: 12.609
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "m430.978 296.007c1.228 1.228 15.487 15.486 22.811 22.811 4.621-2.932 7.691-8.09 7.691-13.968 0-9.132-7.403-16.534-16.534-16.534-5.878 0-11.036 3.07-13.968 7.691z",
    fill: "url(#SVGID_60_)"
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    cx: 481.092,
    cy: 304.85,
    fill: "url(#SVGID_61_)",
    r: 16.534
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    cx: 481.092,
    cy: 304.85,
    fill: "url(#SVGID_62_)",
    r: 12.609
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "m467.124 296.007c1.228 1.228 15.487 15.486 22.811 22.811 4.621-2.932 7.691-8.09 7.691-13.968 0-9.132-7.403-16.534-16.534-16.534-5.878 0-11.036 3.07-13.968 7.691z",
    fill: "url(#SVGID_63_)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "m510 189.215v17.843h-81.145v-6.969c0-6.337 5.137-11.473 11.474-11.473h69.071c.332 0 .6.268.6.599z",
    fill: "url(#SVGID_64_)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "m510 195.532v109.321c0 3.281-2.66 5.941-5.941 5.941h-82.08c-3.281 0-5.941-2.66-5.941-5.941v-103.38c0-3.281 2.66-5.941 5.941-5.941z",
    fill: "url(#SVGID_65_)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "m510 212.656v92.197c0 3.281-2.66 5.941-5.941 5.941h-82.08c-3.281 0-5.941-2.66-5.941-5.941v-92.197z",
    fill: "url(#SVGID_66_)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "m510 279.943v24.91c0 3.281-2.66 5.941-5.941 5.941h-82.08c-3.281 0-5.941-2.66-5.941-5.941v-24.91z",
    fill: "url(#SVGID_67_)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "m416.038 266.77h93.962v7.034h-93.962z",
    fill: "url(#SVGID_68_)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "m510 304.853c0 3.281-2.66 5.941-5.941 5.941h-82.08c-3.281 0-5.941-2.66-5.941-5.941z",
    fill: "url(#SVGID_69_)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "m510 229.043v20.141c-.145.013-.303.026-.448.026h-75.862c-2.674 0-4.834-2.16-4.834-4.835v-10.525c0-2.674 2.16-4.834 4.834-4.834h75.862c.145.001.303.014.448.027z",
    fill: "url(#SVGID_70_)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHighSpeedTrain);
export default __webpack_public_path__ + "static/media/icon-high-speed-train.a3526dab9cb0328634ca47db7e7b42a5.svg";
export { ForwardRef as ReactComponent };